<template>
  <div class="news1">
    <p><b>摘要：</b>对复合芳香涤纶纤维的性能与纺纱特点进行了测试分析，设计出了适合于芳香涤纶纤维性能特点的纺纱工艺，并开发出了复合芳香涤纶纯纺纱、混纺纱及其织物。</p>
    <br><p><b>关键词：</b>复合芳香涤纶；纺纱工艺；纯纺纱线；混纺纱线；织物</p>
    <p>近年来，国外有人提出“环境芳香学”的概念，用以研究生活空间与舒适性的关系以及赋香技术。采用皮芯复合方法制成的芳香短纤维通常作为家庭床上用品和装饰品的填充材料。上海石油化工股份有限公司成功地开发了用于纺纱织造的复合芳香纤维，在国内属首次开发。我们根据复合芳香涤纶纤维的特点，通过多次工艺调整和技术研究，探索出了该纤维的纺纱工艺，生产的纱线已成功用于新型的服装面料和装饰织物，为打开复合芳香涤纶纤维的应用领域提供了有效的借鉴。</p>
    <p><b>1 复合芳香涤纶纤维的特点及物理指标</b></p>
    <p style="color: #999; text-align: center">表1复合芳香涤纶纤维物理指标</p>
    <p><img src="../../assets/img/news12-1.jpg"/></p>
    <p>对纺织品加香的方法一般有三种，即微胶囊法、共混法和皮芯复合法。前两种由于不耐洗和香味持久性差不适于机织物和针织物等产品。上海石油化工股份有限公司采用皮芯结构复合纺丝的方法（即皮芯复合法），将香料放入复合纤维的芯层，由于皮层透气性差，从而可以有效的保持香味缓慢地从纤维两端释放，已达到留香持久和耐洗的目的。由于采用复合纺丝，其纤维的特点与普通涤纶纤维有较大的区别，主要表现在单纤维偏粗，卷曲程度较低，单纤维强度也较低。其物理指标见表1.</p>
    <p><b>2  复合芳香涤纶纤维纺纱工艺流程</b></p>
    <p>由于复合芳香纤维的细度较粗，单独纺纱条干不佳，细纱单强低，断头多，因此不宜单独纯纺，宜与细旦涤纶、纯棉精梳条混纺。</p>
    <p>复合芳香涤纶→A002C型抓棉机→ A006B型混开棉机→（A036C型豪猪开棉机）（跳过）→ A092A型棉箱给棉机→ FA141型单打手成卷机 → A186D型梳棉机</p>
    <p>细特涤纶生条→A002C型抓棉机→ A006B型混开棉机→A036C型豪猪开棉机→ A092A型棉箱给棉机→ FA141型单打手成卷机 → A186D型梳棉机</p>
    <p>纯棉精梳条→A002C型抓棉机→ A006B型混开棉机→A036B型豪猪开棉机→A036C型梳针开棉机→A092A型双棉箱给棉机→A076C型单打手成卷机→ A186F型梳棉机→ FA304型并条机→A191B型条卷机→A201E型精梳棉机</p>
    <p>混和纺纱：</p>
    <p>复合芳香涤纶生条+细特涤纶生条（或纯棉精梳条）：</p>
    <p>A272F型并条机（两道）→ A456D型粗纱机→ FA507型细纱机→ 1332M型络筒机（附电子清纱器，空气捻接器）→ A631C型捻线机→ 1332M型络筒机（附电子清纱器）</p>
    <p><b>3 复合芳香涤纶纤维纺纱工艺及技术措施</b></p>
    <p>复合芳香涤纶纤维除具有常规涤纶纤维的纺纱性能外，还具有其特殊性。由于要保持较好的纤维复合状态，经过各道工序加工后，含有香料的芯层不能暴露在外，以免在织物处理过程中化学试剂对香料的破坏，因此，要求在纺纱过程中尽可能减少对纤维的机械磨损和意外拉伸。针对加工的特殊要求，经过反复探索制定了一套适合加工复合芳香涤纶纤维的纺纱工艺。</p>
    <p>复合芳香涤纶纤维的成纱是涤纶混纺纱（简称涤纶纱 ）和涤棉混纺纱（简称涤棉纱）。由于原料性能的差异与加工要求的不同，我们采用分别处理的方法，对复合芳香涤纶纤维的清棉工序和梳棉工序工艺做了调整，对于普通的细特涤纶和纯棉则采用传统的纺纱工艺流程与工艺参数。然后，在并条工序与细特涤纶生条或纯棉精梳条混并二道，最后加工成涤纶纱线或涤棉纱线。</p>
    <p>3.1  清棉工序</p>
    <p>针对复合芳香涤纶纤维强度低，机械磨损要小的情况，制定了“多松少打、放大隔距、降低速度”的工艺原则，跳过A036C型豪猪开棉机，实行“二刀二箱”的工艺路线，减少“刀”的打击；放大综合打手与给棉罗拉的隔距，减少握持打击力；综合打手速度由960r/min降低到850r/min,减轻打击力度。通过这些工艺参数的调整，有效地减少了纤维打击损伤几率，确保后道工序加工顺利进行。本工序主要工艺参数见表2.</p>
    <p style="color: #999; text-align: center">表2清棉工序主要工艺参数</p>
    <p><img src="../../assets/img/news12-2.jpg"/></p>
    <p>3.2梳棉工序</p>
    <p>梳棉工序是纤维纺纱技术中的重要环节，一方面可以反映出该纤维的可纺性程度，另一方面直接关系到半制品的内在质量，即纱条中纤维的伸直度和条干均匀度，以致最终影响到成纱强力和长片段均匀度。由于复合芳香涤纶纤维的细度偏粗，卷曲程度也较低，所以，纤维间的抱合力较差，梳棉工序加工时转移困难，棉网难以成条，可纺性比常规涤纶差。经过摸索，调整了工艺，即适当加重梳棉生条的定量，增加棉条紧密度，同时相应放大锡林与盖板的隔距，减小锡林与道夫的隔距，加大棉网张力，从而弥补纤维间的抱合力的不足，使锡林和道夫上的纤维能顺利转移成条。另外，降低刺辊速度，提高锡林与刺辊的速比，这样既减少了纤维的打击损伤，又有利于纤维的伸直与分梳，提高成纱质量。本工序主要工艺参数见表3.</p>
    <p style="color: #999; text-align: center">表3  梳棉工序主要工艺参数</p>
    <p><img src="../../assets/img/news12-3.jpg"/></p>
    <p>3.3并条工序</p>
    <p>在并条工序实现两种纤维混和，既要考虑混合均匀性，又要考虑两种混合纤维本身的特性。由于复合芳香涤纶纤维与细特涤纶纤维及棉纤维在细度和长度上存在较大差异，因此，如何在牵伸过程中对纤维进行有效控制是并条工艺首先要解决的问题。一是两道混并工艺（一般混并工艺为三道），既避免长短纤维经多道并合后产生分离与过烂现象，又使整个纺纱过程为奇数工艺，有利于须条中较长的复合芳香涤纶纤维的伸直。二是选择紧隔距、重加压的工艺，有效地控制牵伸力差异较大的两种纤维在牵伸过程中的变速、转移和混和。三是适当降低罗拉速度、稳定牵伸，减少纤维的摩擦损伤。实践证明，混并后的熟条萨氏条干达到15.1%，不匀率为0.65%，取得了较好的效果。本工序主要工艺参数见表4.</p>
    <p style="color: #999; text-align: center">表4.  并条工序主要工艺参数</p>
    <p><img src="../../assets/img/news12-4.jpg"/></p>
    <p>3.4 粗纱工序</p>
    <p>以细纱不出硬头为前提，选择较高的粗纱捻系数，可以进一步改善纤维的抱合力差、须条松烂的状况，有利于提高细纱的条干均匀度。经过小样试验，涤纶线捻系数选择为65，涤棉纱捻系数选择为97，均略高于一般混纺纱。适当降低前罗拉速度，减少纤维机械磨损。本工序主要工艺参数见表5</p>
    <p style="color: #999; text-align: center">表5  粗纱工序主要工艺参数</p>
    <p><img src="../../assets/img/news12-5.jpg"/></p>
    <p>3.5  细纱工序</p>
    <p>细纱工序是影响成纱品质的关键。一般混纺纱采用的工艺原则是紧隔距、重加压、强控制，但小样试纺时发现细纱断头率高，而且黑板条干有短粗节现象。针对复合芳香涤纶纤维抱合力差、强力低、机械磨损要小的特点，在较高的粗纱捻系数的前提下，适当加大后区罗拉隔距，选择适中的后区牵伸倍数，使后区牵伸摩擦力界控制范围增加，避免牵伸力急剧变化，减少纤维变速点突变，从而稳定前区牵伸。另外，适当降低胶辊硬度，选用邵氏硬度在80度左右的胶辊。同时，适当降低车速。经过工艺调整，细纱断头率明显减少，黑板条干大部分都达到一级水平。本工序主要工艺参数见表6.</p>
    <p style="color: #999; text-align: center">表6   细纱工序主要工艺参数</p>
    <p><img src="../../assets/img/news12-6.jpg"/></p>
    <br><p><b>4.  纺纱后加工工艺设计及措施</b></p>
    <p>复合芳香涤纶纤维的混纺纱强力较低，为避免在络筒工序产生磨损断头，较少纱线机械磨损。我们采用低速低张力工艺。槽筒转速降低，张力片几乎不用，拆除锭子“握笔架”上的铁块，严格控制络筒尺寸，这样就使筒子的张力处于适中状态，减少纱线强力损失与毛羽，达到留香持久的要求。另外，根据服装面料的要求，我们生产了一部分复合芳香涤纶线（双股），考虑到织物的风格，股线与单纱的捻度比选为1.4左右。络筒、并捻工序主要工艺参数见表7、表8.</p>
    <p style="color: #999; text-align: center">表7   络筒工序主要工艺参数</p>
    <p><img src="../../assets/img/news12-7.jpg"/></p>
    <p style="color: #999; text-align: center">表8   并捻联合机工艺参数</p>
    <p><img src="../../assets/img/news12-8.jpg"/></p>
    <p><b>5.  质量技术分析</b></p>
    <p>5.1  可纺性分析</p>
    <p>纺织纤维有一些与成纱品质、纺纱加工难易程度有关的综合性能，即可纺性。从复合芳香涤纶纤维各工序加工情况来看，经工艺调整，其纺纱可纺性基本正常。梳棉工序退绕棉层基本正常，清、梳、并工序无纤维和须条堵塞现象，圈绕顺利，但细纱断头率仍偏高。作为新开发的差别化纤维，复合芳香涤纶纤维的可纺性应有进一步的改善的可能，主要表现在其纤维性能方面。首先是纤维的长度与细度，长度长非但不会提高成纱品质，反而会造成加工困难，并增加纱疵；细度偏粗，半制品刚性大，使牵伸、卷绕难以控制，并使成纱截面中纤维根数减少，成纱强度等品质下降。考虑到该纤维的复合纺丝工艺，2.2dtex×40mm的规格应该是较合理的。其次是由于复合芳香涤纶纤维的强度偏低，加上复合状态的差异，直接影响成纱强度，导致细纱断头增加。要进一步开发复合芳香涤纶纤维的纱线织物，提高该纤维的强度是很重要的。再次是复合芳香涤纶纤维的卷曲性能很不稳定，这就影响到纤维之间的抱合力，一般来说，涤纶短纤维卷曲数与卷曲度的乘积在150以上时纤维的纺纱比较顺利，反之，在梳棉工序由于纤维之间的抱合力低，棉网难以分梳转移、剥取成条。纤维卷曲性能还直接影响到纱线的手感、弹性和织物的风格。</p>
    <p>5.2  成纱质量指标测试与分析</p>
    <p style="color: #999; text-align: center">表9复合芳香涤纶成纱质量指标测试</p>
    <p><img src="../../assets/img/news12-9.jpg"/></p>
    <p>复合芳香涤纶成纱质量测试指标见表9。综观复合芳香涤纶纤维的成纱质量，均达到纺织品用纱的质量要求，百米重量CV%与条干水平达到一等纱水平，但成纱强度偏低，毛羽也较多，这与复合芳香涤纶纤维强度低、细度偏粗、长度长（65mm)及卷曲性能有关。因此，进一步改善复合芳香涤纶纤维的性能，提高其成纱质量，是该产品综合开发的关键。</p>
    <p><b>6.  织物开发</b></p>
    <p>由于高新技术的发展和芳香心理学的形成，经过特殊加工的芳香织物能使享用者如沐春风，心旷神怡。这是一种具有高附加值的纺织品，在我国属起步阶段，如何使产品跟上世界潮流是摆在我们面前的一个新课题。根据复合芳香涤纶纤维的特性，混纺涤纶纱中65%为芳香涤纶，35%为1.33dtex细特涤纶。这样既可改善纺纱可纺性，降低纺纱号数，最终提高成纱强度与条干均匀度，又可保持涤纶纱线织物的原有风格，降低成本。为了充分发挥纯棉织物的性能，并利用赋香技术提高其产品的档次，我们配以65%纯棉精梳条与35%芳香涤纶（森林浴香型）混纺，该成纱可以开发服用性较好的织物产品。根据织物品种的要求，加上是首次纺制复合芳香涤纶混纺纱，我们将纱线品种定在纺纱工艺较为成熟的中号纱产品，以18.5tex单纱为主，并纺制部分双股线，拓宽了织物的应用领域。通过纺织品市场调研，我们发现复合芳香涤纶在许多领域有着开发和应用的价值，如针织品、休闲服面料、窗帘等装饰用料以及抗菌除臭、驱虫等保健用品。我们先后和科研单位、服装厂共同开发了下列产品：T/C 18.3 tex （森林浴香型）涤棉针织女性内衣；T19.7tex(森林浴香型）与纯棉色纱针织T恤衫；T15.5×2(桂花香型）（经）与T/C 65/35 36.4 （纬）涤纶线纯棉纱交织免烫休闲面料；T/C18.3tex涤棉纱（经）与T18.5tex（茉莉香）涤纶纱（纬）交织色织高级衬衫面料。</p>
    <p>在产品的开发过程中，我们也发现了一些有待进一步完善的问题，如纤维品质的均匀性和复合包络的成功度，织物经染色、后整理过程后留香持久的问题。这些问题通过不断研究和实践是可以解决的。</p>
    <p><b>7. 结语</b></p>
    <p>（1）通过纺纱技术的研究及工艺调整，复合芳香涤纶纤维的纺纱工艺是可行的，其特点是减少纤维机械磨损，改善纺纱可纺性，稳定牵伸，提高成纱强度与条干均匀度。</p>
    <p>（2）提高复合芳香涤纶纤维的强度、降低其细度、改善卷曲性能，这是提高成纱质量和纺织品档次的关键。</p>
    <p>（3）复合芳香涤纶纤维按适当的比例进行混纺和交织，不仅可以保留原有织物的性能和风格，而且可以开发纺织品的赋香新功能，赋予纺织高精技术新含义。</p>
    <p>（4）复合芳香涤纶纤维及纺织品的开发对开拓国内纺织品市场具有积极意义，特别是国内市场在这方面刚刚起步，它的开发应用必将成为纺织工业新的增长点。</p>
    <p style="color: #999; text-align: center">来源：TTEB</p>
  </div>

</template>
<script>
  export default {
    name: 'news12'
  }
</script>

<style scoped>
  .news1{
    text-align: left;
    font-size: 18px;
    line-height: 200%;
    background: #fff;
    color: #333;
    margin-top: -10px;
    padding: 20px 30px;
  }

  .news1 p{
    font-family: 微软雅黑;
    text-indent: 2em;
    line-height: 145%;
    margin: 12px 0;
  }

  .news1 p img{
    display: block;
    max-width: 100%;
    margin: 12px auto;
  }

</style>



// WEBPACK FOOTER //
// src/views/new/news12.vue